import {
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  PrinterIcon,
  UserIcon,
  CalendarIcon,
  TrendingUpIcon,
  ChartBarIcon
} from '@heroicons/react/outline';

import {
  useEffect,
  useState,
  useRef
} from 'react';

import swal from 'sweetalert';

import {
  selectCurrentUser
} from '../../Features/auth/authSlice';

import {
  useDispatch,
  useSelector
} from 'react-redux';

import LoadingBar from "react-top-loading-bar";

import { useIsOnline } from 'react-use-is-online';

import ReactPaginate from 'react-paginate';

import { motion, AnimatePresence } from 'framer-motion';

import { format } from 'date-fns';

import {
  DateRangePicker
} from "react-date-range";

import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

import {
  addDays,
  subDays
} from "date-fns";

import {
  useGetUserEmployeesQuery
} from '../../Features/userEmployeesSlice';

import {
  Bar
} from "react-chartjs-2";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  ArcElement,
  Tooltip,
  Legend,
  PointElement
} from "chart.js";

import {
  useGetSalesByRoutePageChangeMutation,
  useGetSalesByRouteQuery,
  useGetSalesByRouteWithDateRangeMutation
} from '../../Features/userReportsSlice';

import {
  selectDateRange,
  setDateRange
} from '../../Features/date/dateSlice';

import { useTheme } from "../../ThemeContext";


ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  ArcElement,
  Tooltip,
  Legend,
  PointElement
);


function SalesByRouteView({}) {

  const { darkMode } = useTheme();

  const user = useSelector(selectCurrentUser);

  const date_range = useSelector(selectDateRange);

  const dispatch = useDispatch();

  const [progress, setProgress] = useState(0);

  const { isOnline } = useIsOnline();

  const [numRowsPerPage, setNumRowsPerPage] = useState(10);

  const [currentItems, setCurrentItems] = useState([]);

  const [stats, setStats] = useState([]);

  const [pageCount, setPageCount] = useState(0);

  const [currentPage, setCurrentPage] = useState(0);

  const [open, setOpen] = useState(false);

  const [selectedEmployee, setSelectedEmployee] = useState(0);

  const pickerRef = useRef(null);

  const [isExporting, setIsExporting] = useState(false);

  const [isSelecting, setIsSelecting] = useState(false);

  const [selectedStartDate, setSelectedStartDate] = useState(false);

  const [selectedEndDate, setSelectedEndDate] = useState(false);


  const [state, setState] = useState([
    {
      startDate: subDays(new Date(), 7),
      endDate: addDays(new Date(), 1),
      key: "selection"
    }
  ]);


  /* =========================================================
     ORIGINAL DATE LOGIC - UNCHANGED
  ========================================================= */

  const initialStartDate = (date_range)
    ? format(
        date_range.startDate,
        "yyyy-MM-dd"
      )
    : format(
        subDays(new Date(), 7),
        "yyyy-MM-dd"
      );


  const initialEndDate = (date_range)
    ? format(
        date_range.endDate,
        "yyyy-MM-dd"
      )
    : format(
        subDays(new Date(), 0),
        "yyyy-MM-dd"
      );


  /* =========================================================
     ORIGINAL QUERY - UNCHANGED
  ========================================================= */

  const {
    data: resp,
    isLoading,
    isSuccess,
  } = useGetSalesByRouteQuery({
    user_id: user.id,
    pagination: '10',
    start_date: initialStartDate,
    end_date: initialEndDate,
    employee_id: selectedEmployee,
  });


  /* =========================================================
     ORIGINAL EMPLOYEE QUERY - UNCHANGED
  ========================================================= */

  const {
    data: employees,
  } = useGetUserEmployeesQuery({
    account_id: user.id,
    paginate: 10
  });


  /* =========================================================
     ORIGINAL EFFECT - UNCHANGED
  ========================================================= */

  useEffect(() => {

    setProgress(40);

    if (isLoading) {
      setProgress(80);
    }

    if (isSuccess && resp?.data) {

      setCurrentItems(
        resp.data.routes.data
      );

      setStats(
        resp.data.top_ten
      );

      setPageCount(
        Math.ceil(
          resp.data.routes.meta.total /
          resp.data.routes.meta.per_page
        )
      );

    }

    setProgress(100);


    const handleClickOutside = (event) => {

      if (
        pickerRef.current &&
        !pickerRef.current.contains(
          event.target
        )
      ) {
        setOpen(false);
      }

    };


    document.addEventListener(
      "mousedown",
      handleClickOutside
    );


    return () => {

      document.removeEventListener(
        "mousedown",
        handleClickOutside
      );

    };

  }, [resp]);


  /* =========================================================
     ORIGINAL EMPLOYEE CHANGE - UNCHANGED
  ========================================================= */

  const handleEmployeeChange = (
    e,
    employeeId
  ) => {

    submitSearch(
      e,
      employeeId
    );

  };


  /* =========================================================
     ORIGINAL DATE RANGE MUTATION - UNCHANGED
  ========================================================= */

  const [fetchCustomData] =
    useGetSalesByRouteWithDateRangeMutation();


  /* =========================================================
     ORIGINAL DATE RANGE HANDLER - UNCHANGED
  ========================================================= */

  const handleSelect = async (ranges) => {

    setCurrentPage(0);

    const { selection } = ranges;

    setState([
      selection
    ]);


    if (!isSelecting) {

      setIsSelecting(true);

      return;

    }


    setIsSelecting(false);

    setOpen(false);


    const startDate =
      format(
        selection.startDate,
        "yyyy-MM-dd"
      );


    const endDate =
      format(
        selection.endDate,
        "yyyy-MM-dd"
      );


    dispatch(
      setDateRange({
        date_range: selection
      })
    );


    setSelectedStartDate(
      startDate
    );


    setSelectedEndDate(
      endDate
    );


    try {

      setProgress(80);


      const resp =
        await fetchCustomData({

          user_id: user.id,

          pagination:
            numRowsPerPage,

          start_date:
            startDate,

          end_date:
            endDate,

          employee_id:
            selectedEmployee
              ? selectedEmployee
              : "0",

        }).unwrap();


      setSelectedEmployee('');


      if (resp.success) {

        setCurrentItems(
          resp.data.routes.data
        );

        setStats(
          resp.data.top_ten
        );

        setPageCount(
          Math.ceil(
            resp.data.routes.meta.total /
            resp.data.routes.meta.per_page
          )
        );

      }

    } catch (err) {

      swal(
        "Error",
        "Data not found"
      );

    } finally {

      setProgress(100);

    }

  };


  /* =========================================================
     ORIGINAL PAGINATION MUTATION - UNCHANGED
  ========================================================= */

  const [pageChange] =
    useGetSalesByRoutePageChangeMutation();


  /* =========================================================
     ORIGINAL ROW COUNT HANDLER - UNCHANGED
  ========================================================= */

  const onChangePageRows = async (
    rows
  ) => {

    setCurrentPage(0);

    let nunRows =
      window.parseInt(rows);

    setNumRowsPerPage(
      nunRows
    );


    let startDate =
      selectedStartDate
        ? selectedStartDate
        : initialStartDate;


    let endDate =
      selectedEndDate
        ? selectedEndDate
        : initialEndDate;


    try {

      setProgress(80);


      const resp =
        await pageChange({

          user_id:
            user.id,

          pagination:
            nunRows,

          start_date:
            startDate,

          end_date:
            endDate,

          employee_id:
            selectedEmployee
              ? selectedEmployee
              : "0",

          page: 1

        }).unwrap();


      if (resp.success) {

        setCurrentItems(
          resp.data.routes.data
        );


        setPageCount(
          Math.ceil(
            resp.data.routes.meta.total /
            resp.data.routes.meta.per_page
          )
        );


        setProgress(100);

      }

    } catch (err) {

      setProgress(100);

      swal(
        "Error",
        "An expected error. Try again later"
      );

    }

  };


  /* =========================================================
     ORIGINAL PAGE CHANGE HANDLER - UNCHANGED
  ========================================================= */

  const handlePageChange = async (
    currentPage
  ) => {

    setCurrentPage(
      currentPage
    );


    let pageNum =
      window.parseInt(
        currentPage
      ) + 1;


    let startDate =
      selectedStartDate
        ? selectedStartDate
        : initialStartDate;


    let endDate =
      selectedEndDate
        ? selectedEndDate
        : initialEndDate;


    try {

      setProgress(80);


      const resp =
        await pageChange({

          user_id:
            user.id,

          pagination:
            numRowsPerPage,

          start_date:
            startDate,

          end_date:
            endDate,

          employee_id:
            selectedEmployee
              ? selectedEmployee
              : "0",

          page:
            pageNum

        }).unwrap();


      if (resp.success) {

        setCurrentItems(
          resp.data.routes.data
        );


        setPageCount(
          Math.ceil(
            resp.data.routes.meta.total /
            resp.data.routes.meta.per_page
          )
        );


        setProgress(100);

      }

    } catch (err) {

      setProgress(100);

      swal(
        "Error",
        "An expected error. Try again later"
      );

    }

  };


  /* =========================================================
     ORIGINAL EMPLOYEE SEARCH - UNCHANGED
  ========================================================= */

  const submitSearch = async (
    e,
    user_employee_id = false
  ) => {

    setCurrentPage(0);


    let employee_id =
      user_employee_id
        ? user_employee_id
        : '0';


    e.preventDefault();


    try {

      setProgress(80);


      const resp =
        await fetchCustomData({

          user_id:
            user.id,

          pagination:
            numRowsPerPage,

          start_date:
            selectedStartDate
              ? selectedStartDate
              : initialStartDate,

          end_date:
            selectedEndDate
              ? selectedEndDate
              : initialEndDate,

          employee_id:
            employee_id,

        }).unwrap();


      if (
        resp.data.routes.data
      ) {

        setCurrentItems(
          resp.data.routes.data
        );

        setStats(
          resp.data.top_ten
        );

        setPageCount(
          Math.ceil(
            resp.data.routes.meta.total /
            resp.data.routes.meta.per_page
          )
        );

        return setProgress(100);

      }


      setProgress(100);

      return swal(
        'No results found...'
      );


    } catch (err) {

      setProgress(100);

      swal(
        'No results found...'
      );

    }

  };


  /* =========================================================
     ORIGINAL EXPORT - UNCHANGED
  ========================================================= */

  const handleExportCSV = async () => {

    try {

      setIsExporting(true);


      const employee_id =
        selectedEmployee || 0;


      const startDate =
        state[0]?.startDate
          ? state[0].startDate
              .toISOString()
              .split("T")[0]
          : 0;


      const endDate =
        state[0]?.endDate
          ? state[0].endDate
              .toISOString()
              .split("T")[0]
          : 0;


      const response =
        await fetch(
          `http://127.0.0.1:8000/user/sales-by-route/${user.id}/1000/${startDate}/${endDate}/${selectedEmployee ? selectedEmployee : "0"}`
        );


      const result =
        await response.json();


      if (
        !result.success ||
        !result.data?.routes?.data?.length
      ) {

        swal(
          "No data",
          "No route sales records found",
          "info"
        );


        setIsExporting(false);

        return;

      }


      const routes =
        result.data.routes.data;


      const headers = [

        "Route Name",

        "Category",

        "Total Tickets",

        "Gross Sales (K)",

        "Discounts (K)",

        "Refunds (K)",

        "Net Sales (K)",

        "Cost of Goods (K)",

        "Gross Profit (K)",

        "Margin (%)",

        "Taxes (K)"

      ];


      const rows =
        routes.map(
          r => [

            r.route_name,

            r.category_name ?? "",

            r.total_tickets,

            r.gross_sales,

            r.total_discounts,

            r.refund_amount,

            r.net_sales,

            r.cost_of_goods,

            r.gross_profit,

            r.margin_percent,

            r.total_taxes

          ]
        );


      const csvContent =
        [
          headers,
          ...rows
        ]

          .map(
            row =>

              row
                .map(
                  value =>
                    `"${String(
                      value ?? ""
                    ).replace(
                      /"/g,
                      '""'
                    )}"`
                )
                .join(",")
          )

          .join("\n");


      const blob =
        new Blob(
          [csvContent],
          {
            type:
              "text/csv;charset=utf-8;"
          }
        );


      const url =
        URL.createObjectURL(
          blob
        );


      const link =
        document.createElement(
          "a"
        );


      link.href =
        url;


      link.download =
        `sales_by_route_${new Date()
          .toISOString()
          .split("T")[0]}.csv`;


      link.click();


      URL.revokeObjectURL(
        url
      );


      setIsExporting(false);


    } catch (error) {

      swal(
        "Error",
        "Failed to export sales by route",
        "error"
      );


      setIsExporting(false);

    }

  };


  /* =========================================================
     CHART - ORIGINAL LOGIC - DO NOT EDIT
  ========================================================= */

  const renderChart = () => {

    if (
      !Array.isArray(stats) ||
      stats.length === 0
    ) {

      return (

        <div
          className="
            h-full
            flex
            items-center
            justify-center
            text-sm
            text-slate-400
            dark:text-slate-500
          "
        >
          No chart data available
        </div>

      );

    }


    const dates =
      stats.map(
        d => d.date
      );


    const labels =
      stats.map(
        d =>
          format(
            new Date(d.date),
            "MMM dd"
          )
      );


    const routeTotals = {};


    stats.forEach(
      day => {

        day.routes.forEach(
          r => {

            routeTotals[
              r.route_name
            ] =
              (
                routeTotals[
                  r.route_name
                ] || 0
              ) +
              Number(
                r.gross_sales || 0
              );

          }
        );

      }
    );


    const routes =
      Object.entries(
        routeTotals
      )
        .sort(
          (a, b) =>
            b[1] - a[1]
        )
        .map(
          ([route]) =>
            route
        );


    const colors = [

      "#5f6f77",

      "#80b643",

      "#d6d604",

      "#FF5993",

      "#8b5cf6",

      "#45adf3",

      "#6366f1",

      "#80b643",

      "#eab308",

      "#ec4899"

    ];


    const datasets =
      routes.map(
        (
          route,
          i
        ) => {

          const data =
            dates.map(
              date => {

                const day =
                  stats.find(
                    d =>
                      d.date === date
                  );


                const r =
                  day?.routes.find(
                    x =>
                      x.route_name === route
                  );


                return r
                  ? Number(
                      r.gross_sales
                    )
                  : 0;

              }
            );


          const totalGrossSales =
            data.reduce(
              (
                sum,
                val
              ) =>
                sum + val,
              0
            );


          return {

            label:
              `${route} (K ${totalGrossSales.toLocaleString(
                "en-ZM"
              )})`,

            data,

            backgroundColor:
              colors[
                i %
                colors.length
              ],

            stack:
              "sales"

          };

        }
      );


    return (

      <Bar

        data={{
          labels: labels,
          datasets
        }}


        options={{

          responsive: true,

          maintainAspectRatio: false,


          scales: {

            x: {

              stacked: true,

              ticks: {

                color:
                  darkMode
                    ? "#FFFFFF"
                    : "#374151",

                font: {
                  size: 11
                }

              },

              grid: {

                color:
                  darkMode
                    ? "#374151"
                    : "#E5E7EB"

              }

            },


            y: {

              stacked: true,

              ticks: {

                callback:
                  v =>
                    v.toLocaleString(
                      "en-ZM"
                    ),

                color:
                  darkMode
                    ? "#FFFFFF"
                    : "#374151",

                font: {
                  size: 11
                }

              },

              grid: {

                color:
                  darkMode
                    ? "#374151"
                    : "#E5E7EB"

              }

            }

          },


          plugins: {

            legend: {

              position:
                "left",

              align:
                "center",

              labels: {

                boxWidth:
                  12,

                padding:
                  15,

                color:
                  darkMode
                    ? "#FFFFFF"
                    : "#374151",

              }

            },


            tooltip: {

              backgroundColor:
                darkMode
                  ? "#0f172a"
                  : "#ffffff",

              titleColor:
                darkMode
                  ? "#ffffff"
                  : "#0f172a",

              bodyColor:
                darkMode
                  ? "#e2e8f0"
                  : "#475569",

              borderColor:
                darkMode
                  ? "#334155"
                  : "#e2e8f0",

              borderWidth:
                1,

              padding:
                12,

              callbacks: {

                label:
                  ctx =>
                    `${ctx.dataset.label.split(" (")[0]}: K ${ctx.parsed.y.toLocaleString(
                      "en-ZM"
                    )}`

              }

            },


            datalabels: {

              formatter:
                () => null

            }

          }

        }}

      />

    );

  };


  /* =========================================================
     MODERN TELLERPOINT UI
  ========================================================= */

  return (

    <div
      className="
        w-full
        min-h-screen
        bg-gray-100
        dark:bg-gray-950
        text-gray-800
        dark:text-white
        pb-12
      "
    >

      <LoadingBar
        color="#80b643"
        height="4px"
        progress={progress}
        onLoaderFinished={() =>
          setProgress(0)
        }
      />


      {/* =====================================================
          PAGE HEADER
      ===================================================== */}

      <div
        className="
          px-4
          sm:px-6
          lg:px-8
          pt-6
        "
      >

        <div
          className="
            flex
            flex-col
            xl:flex-row
            xl:items-center
            xl:justify-between
            gap-5
          "
        >

          <div>

            <div
              className="
                flex
                items-center
                gap-3
              "
            >

              <div
                className="
                  w-11
                  h-11
                  rounded-xl
                  bg-[#80b643]/10
                  dark:bg-[#80b643]/20
                  flex
                  items-center
                  justify-center
                  shrink-0
                "
              >

                <TrendingUpIcon
                  className="
                    w-6
                    h-6
                    text-[#80b643]
                  "
                />

              </div>


              <div>

                <h1
                  className="
                    text-lg
                    sm:text-xl
                    font-semibold
                    text-gray-900
                    dark:text-white
                  "
                >
                  Sales by Route
                </h1>


                <p
                  className="
                    text-sm
                    text-gray-500
                    dark:text-gray-400
                    mt-0.5
                  "
                >
                  View sales performance and revenue
                  generated across your routes.
                </p>

              </div>

            </div>

          </div>


          {/* =================================================
              FILTERS
          ================================================= */}

          <div
            className="
              flex
              flex-col
              sm:flex-row
              sm:flex-wrap
              gap-3
              w-full
              xl:w-auto
            "
          >

            {/* DATE RANGE */}

            <div
              className="
                relative
                w-full
                sm:w-auto
              "
            >

              <button
                type="button"
                onClick={() =>
                  setOpen(!open)
                }
                className="
                  w-full
                  sm:w-auto
                  min-h-[42px]
                  flex
                  items-center
                  justify-center
                  gap-2
                  px-4
                  py-2.5
                  rounded-xl
                  bg-white
                  dark:bg-gray-900
                  border
                  border-gray-200
                  dark:border-gray-800
                  text-sm
                  text-gray-600
                  dark:text-gray-200
                  shadow-sm
                  hover:border-[#80b643]
                  hover:text-[#80b643]
                  transition
                  whitespace-nowrap
                "
              >

                <CalendarIcon
                  className="
                    w-4
                    h-4
                    text-[#80b643]
                    shrink-0
                  "
                />


                <span>

                  {`${format(
                    date_range
                      ? date_range.startDate
                      : state[0].startDate,
                    'MMM dd, yyyy'
                  )} → ${format(
                    date_range
                      ? date_range.endDate
                      : state[0].endDate,
                    'MMM dd, yyyy'
                  )}`}

                </span>

              </button>


              <AnimatePresence>

                {open && (

                  <motion.div
                    ref={pickerRef}

                    initial={{
                      opacity: 0,
                      y: -10
                    }}

                    animate={{
                      opacity: 1,
                      y: 0
                    }}

                    exit={{
                      opacity: 0,
                      y: -10
                    }}

                    transition={{
                      duration: 0.2
                    }}

                    className="
                      absolute
                      right-0
                      z-50
                      mt-2
                      bg-white
                      dark:bg-gray-900
                      shadow-2xl
                      border
                      border-gray-200
                      dark:border-gray-800
                      rounded-2xl
                      p-3
                      overflow-hidden
                      max-w-[calc(100vw-2rem)]
                    "
                  >

                    <DateRangePicker

                      onChange={
                        handleSelect
                      }

                      showSelectionPreview={
                        true
                      }

                      moveRangeOnFirstSelection={
                        false
                      }

                      months={1}

                      ranges={
                        state
                      }

                      direction={
                        "horizontal"
                      }

                    />

                  </motion.div>

                )}

              </AnimatePresence>

            </div>


            {/* EMPLOYEE */}

            <div
              className="
                relative
                w-full
                sm:w-auto
              "
            >

              <UserIcon
                className="
                  absolute
                  left-3
                  top-3
                  w-4
                  h-4
                  text-[#80b643]
                  pointer-events-none
                  z-10
                "
              />


              <select

                value={
                  selectedEmployee
                }

                onChange={(e) => {

                  setSelectedEmployee(
                    e.target.value
                  );

                  handleEmployeeChange(
                    e,
                    e.target.value
                  );

                }}

                className="
                  appearance-none
                  w-full
                  sm:w-[220px]
                  min-h-[42px]
                  bg-white
                  dark:bg-gray-900
                  border
                  border-gray-200
                  dark:border-gray-800
                  pl-9
                  pr-10
                  py-2.5
                  rounded-xl
                  text-sm
                  text-gray-600
                  dark:text-gray-200
                  shadow-sm
                  hover:border-[#80b643]
                  focus:outline-none
                  focus:ring-2
                  focus:ring-[#80b643]/20
                  focus:border-[#80b643]
                  cursor-pointer
                  transition
                "
              >

                <option value="">
                  All Employees
                </option>


                {employees?.data?.data?.map(
                  (item) => (

                    <option
                      key={item.id}
                      value={item.id}
                    >

                      {item.fname}{" "}
                      {item.lname}

                    </option>

                  )
                )}

              </select>


              <ChevronDownIcon
                className="
                  absolute
                  right-3
                  top-3
                  w-4
                  h-4
                  text-gray-400
                  pointer-events-none
                "
              />

            </div>

          </div>

        </div>

      </div>


      {/* =====================================================
          CHART CARD
          CHART ITSELF IS UNCHANGED
      ===================================================== */}

      <div
        className="
          px-4
          sm:px-6
          lg:px-8
          mt-6
        "
      >

        <div
          className="
            bg-white
            dark:bg-gray-900
            border
            border-gray-200
            dark:border-gray-800
            rounded-xl
            shadow-sm
            overflow-hidden
          "
        >

          <div
            className="
              px-4
              sm:px-6
              py-4
              border-b
              border-gray-100
              dark:border-gray-800
              flex
              items-center
              gap-3
            "
          >

            <div
              className="
                w-10
                h-10
                rounded-xl
                bg-[#80b643]/10
                dark:bg-[#80b643]/20
                flex
                items-center
                justify-center
                shrink-0
              "
            >

              <ChartBarIcon
                className="
                  w-5
                  h-5
                  text-[#80b643]
                "
              />

            </div>


            <div>

              <h2
                className="
                  text-base
                  sm:text-lg
                  font-semibold
                  text-gray-900
                  dark:text-white
                "
              >
                Sales by Route
              </h2>


              <p
                className="
                  text-xs
                  sm:text-sm
                  text-gray-500
                  dark:text-gray-400
                  mt-0.5
                "
              >
                Gross sales performance across routes
                for the selected period.
              </p>

            </div>

          </div>


          <div
            className="
              relative
              h-[350px]
              sm:h-[400px]
              p-3
              sm:p-5
              lg:p-6
              overflow-x-auto
            "
          >

            {renderChart()}

          </div>

        </div>

      </div>


      {/* =====================================================
          ROUTE SALES TABLE
      ===================================================== */}

      {currentItems.length > 0 && (

        <div
          className="
            px-4
            sm:px-6
            lg:px-8
            mt-6
          "
        >

          <div
            className="
              bg-white
              dark:bg-gray-900
              border
              border-gray-200
              dark:border-gray-800
              rounded-xl
              shadow-sm
              overflow-hidden
            "
          >

            {/* TABLE HEADER */}

            <div
              className="
                px-4
                sm:px-6
                py-4
                flex
                flex-col
                sm:flex-row
                sm:items-center
                sm:justify-between
                gap-4
                border-b
                border-gray-100
                dark:border-gray-800
              "
            >

              <div>

                <h2
                  className="
                    text-base
                    sm:text-lg
                    font-semibold
                    text-gray-900
                    dark:text-white
                  "
                >
                  Route Sales Details
                </h2>


                <p
                  className="
                    text-xs
                    sm:text-sm
                    text-gray-500
                    dark:text-gray-400
                    mt-0.5
                  "
                >
                  Detailed sales breakdown by route
                  and category.
                </p>

              </div>


              <button

                type="button"

                onClick={
                  handleExportCSV
                }

                disabled={
                  isExporting
                }

                className={`
                  inline-flex
                  items-center
                  justify-center
                  gap-2
                  px-4
                  py-2.5
                  rounded-xl
                  text-sm
                  font-medium
                  border
                  transition
                  w-full
                  sm:w-auto

                  ${
                    isExporting
                      ? `
                        bg-gray-100
                        dark:bg-gray-800
                        text-gray-400
                        border-gray-200
                        dark:border-gray-700
                        cursor-not-allowed
                      `
                      : `
                        bg-[#80b643]/10
                        dark:bg-[#80b643]/20
                        text-[#80b643]
                        border-[#80b643]/20
                        hover:bg-[#80b643]/20
                        dark:hover:bg-[#80b643]/30
                      `
                  }
                `}
              >

                <PrinterIcon
                  className="
                    w-4
                    h-4
                  "
                />


                {isExporting
                  ? "Exporting..."
                  : "Export CSV"
                }

              </button>

            </div>


            {/* DESKTOP TABLE */}

            <div
              className="
                overflow-x-auto
                w-full
              "
            >

              <table
                className="
                  w-full
                  min-w-[1050px]
                  table-auto
                "
              >

                <thead
                  className="
                    bg-gray-50
                    dark:bg-gray-800/70
                    border-b
                    border-gray-200
                    dark:border-gray-800
                  "
                >

                  <tr>

                    <TableHeader>
                      Route
                    </TableHeader>

                    <TableHeader>
                      Category
                    </TableHeader>

                    <TableHeader>
                      Sales
                    </TableHeader>

                    <TableHeader>
                      Gross Sales
                    </TableHeader>

                    <TableHeader>
                      Refunds
                    </TableHeader>

                    <TableHeader>
                      Discounts
                    </TableHeader>

                    <TableHeader>
                      Net Sales
                    </TableHeader>

                    <TableHeader>
                      Cost of Goods
                    </TableHeader>

                    <TableHeader>
                      Gross Profit
                    </TableHeader>

                    <TableHeader>
                      Margin
                    </TableHeader>

                    <TableHeader>
                      Taxes
                    </TableHeader>

                  </tr>

                </thead>


                <tbody
                  className="
                    divide-y
                    divide-gray-100
                    dark:divide-gray-800
                  "
                >

                  {currentItems.map(
                    route => (

                      <tr
                        key={
                          route.route_id
                        }

                        className="
                          hover:bg-gray-50
                          dark:hover:bg-gray-800/40
                          transition
                        "
                      >

                        <TableCell >
                          <div
                            className="
                              flex
                              items-center
                              gap-2
                            "
                          >

                            <div
                              className="
                                w-8
                                h-8
                                rounded-lg
                                bg-[#80b643]/10
                                dark:bg-[#80b643]/20
                                flex
                                items-center
                                justify-center
                                shrink-0
                              "
                            >

                              <TrendingUpIcon
                                className="
                                  w-4
                                  h-4
                                  text-[#80b643]
                                "
                              />

                            </div>


                            <span>
                              {route.route_name}
                            </span>

                          </div>
                        </TableCell>


                        <TableCell>
                          {route.category_name || "-"}
                        </TableCell>


                        <TableCell>
                          {route.total_tickets}
                        </TableCell>


                        <TableCell>
                          K {route.gross_sales}
                        </TableCell>


                        <TableCell>
                          K {route.refund_amount}
                        </TableCell>


                        <TableCell>
                          K {route.total_discounts}
                        </TableCell>


                        <TableCell>
                          K {route.net_sales}
                        </TableCell>


                        <TableCell>
                          K {route.cost_of_goods}
                        </TableCell>


                        <TableCell>
                          K {route.gross_profit}
                        </TableCell>


                        <TableCell>

                          <span
                            className="
                              inline-flex
                              items-center
                              px-2
                              py-1
                              rounded-lg
                              bg-[#80b643]/10
                              dark:bg-[#80b643]/20
                              text-[#80b643]
                              text-xs
                              font-semibold
                            "
                          >
                            {route.margin_percent}%
                          </span>

                        </TableCell>


                        <TableCell>
                          K {route.total_taxes}
                        </TableCell>

                      </tr>

                    )
                  )}

                </tbody>

              </table>

            </div>


            {/* =================================================
                PAGINATION
            ================================================= */}

            <div
              className="
                px-4
                sm:px-6
                py-4
                border-t
                border-gray-100
                dark:border-gray-800
                flex
                flex-col
                sm:flex-row
                items-center
                justify-between
                gap-4
              "
            >

              <div
                className="
                  w-full
                  sm:w-auto
                  overflow-x-auto
                "
              >

                <ReactPaginate

                  breakLabel="..."

                  nextLabel={
                    <ChevronRightIcon
                      className="
                        w-5
                        h-5
                      "
                    />
                  }

                  onPageChange={
                    (e) =>
                      handlePageChange(
                        e.selected
                      )
                  }

                  pageRangeDisplayed={
                    3
                  }

                  pageCount={
                    pageCount
                  }

                  forcePage={
                    currentPage
                  }

                  previousLabel={
                    <ChevronLeftIcon
                      className="
                        w-5
                        h-5
                      "
                    />
                  }

                  renderOnZeroPageCount={
                    null
                  }

                  containerClassName="
                    flex
                    items-center
                    gap-1
                    w-max
                  "

                  pageLinkClassName="
                    flex
                    items-center
                    justify-center
                    min-w-[32px]
                    h-8
                    px-2
                    rounded-lg
                    text-sm
                    text-gray-500
                    dark:text-gray-400
                    hover:bg-gray-100
                    dark:hover:bg-gray-800
                    hover:text-[#80b643]
                    transition
                    cursor-pointer
                  "

                  previousLinkClassName="
                    flex
                    items-center
                    justify-center
                    w-8
                    h-8
                    rounded-lg
                    text-gray-500
                    dark:text-gray-400
                    hover:bg-gray-100
                    dark:hover:bg-gray-800
                    hover:text-[#80b643]
                    transition
                    cursor-pointer
                  "

                  nextLinkClassName="
                    flex
                    items-center
                    justify-center
                    w-8
                    h-8
                    rounded-lg
                    text-gray-500
                    dark:text-gray-400
                    hover:bg-gray-100
                    dark:hover:bg-gray-800
                    hover:text-[#80b643]
                    transition
                    cursor-pointer
                  "

                  activeLinkClassName="
                    !bg-[#80b643]
                    !text-white
                  "

                />

              </div>


              {/* ROWS PER PAGE */}

              <div
                className="
                  flex
                  items-center
                  justify-center
                  gap-2
                  text-sm
                  text-gray-500
                  dark:text-gray-400
                  w-full
                  sm:w-auto
                  shrink-0
                "
              >

                <span>
                  Rows per page
                </span>


                <select

                  defaultValue="10"

                  onChange={(e) =>
                    onChangePageRows(
                      e.target.value
                    )
                  }

                  className="
                    bg-white
                    dark:bg-gray-900
                    border
                    border-gray-200
                    dark:border-gray-700
                    rounded-lg
                    px-3
                    py-1.5
                    text-sm
                    text-gray-600
                    dark:text-gray-200
                    focus:outline-none
                    focus:ring-2
                    focus:ring-[#80b643]/20
                    focus:border-[#80b643]
                  "
                >

                  <option value="10">
                    10
                  </option>

                  <option value="25">
                    25
                  </option>

                  <option value="50">
                    50
                  </option>

                  <option value="100">
                    100
                  </option>

                </select>

              </div>

            </div>

          </div>

        </div>

      )}


      {/* =====================================================
          NO DATA
      ===================================================== */}

      {currentItems.length === 0 && !isLoading && (

        <div
          className="
            px-4
            sm:px-6
            lg:px-8
            mt-6
          "
        >

          <div
            className="
              bg-white
              dark:bg-gray-900
              border
              border-gray-200
              dark:border-gray-800
              rounded-xl
              shadow-sm
              p-10
              text-center
            "
          >

            <div
              className="
                mx-auto
                w-12
                h-12
                rounded-xl
                bg-[#80b643]/10
                dark:bg-[#80b643]/20
                text-[#80b643]
                flex
                items-center
                justify-center
              "
            >

              <ChartBarIcon
                className="
                  w-6
                  h-6
                "
              />

            </div>


            <h3
              className="
                mt-4
                text-base
                font-semibold
                text-gray-900
                dark:text-white
              "
            >
              No route sales found
            </h3>


            <p
              className="
                mt-1
                text-sm
                text-gray-500
                dark:text-gray-400
              "
            >
              Try selecting another date range or
              employee.
            </p>

          </div>

        </div>

      )}

    </div>

  );

}


/* =========================================================
   TABLE HEADER
========================================================= */

function TableHeader({
  children
}) {

  return (

    <th
      className="
        px-3
        lg:px-4
        xl:px-5
        py-3.5
        text-left
        text-[11px]
        font-semibold
        text-gray-500
        dark:text-gray-400
        uppercase
        tracking-wider
        whitespace-nowrap
      "
    >
      {children}
    </th>

  );

}


/* =========================================================
   TABLE CELL
========================================================= */

function TableCell({
  children,
  bold = false
}) {

  return (

    <td
      className={`

        px-3
        lg:px-4
        xl:px-5

        py-3.5

        whitespace-nowrap

        text-xs
        lg:text-sm

        ${
          bold
            ? `
              font-semibold
              text-gray-900
              dark:text-white
            `
            : `
              text-gray-600
              dark:text-gray-300
            `
        }

      `}
    >
      {children}
    </td>

  );

}


export default SalesByRouteView;